import { rest } from "lodash";
import axios from "./axiosInstance";
import { EndPtTronRentResourceBalance } from "@wallet-manager/node-types/dist/src/access/const/AccessAPIEndPoints";

const getTronWalletResourceBalanceListDummyRes = {
  rows: [
    // create dummy date base on ITronWalletResourceBalance
    {
      merchant_id: "M123456",
      chain_type: 8,
      chain_id: 2,
      wallet_address: "T1234567890abcdefg",
      energy: 1000,
      bandwidth: 2000,
      last_block_number: 12345678,
      last_block_time: "2023-10-01T12:00:00Z",
      created_date: "2023-10-01T12:00:00Z",
      last_modified_date: "2023-10-01T12:00:00Z",
    },
    {
      merchant_id: "M654321",
      chain_type: 8,
      chain_id: 2,
      wallet_address: "Tabcdefg1234567890",
      energy: 1500,
      bandwidth: 2500,
      last_block_number: 87654321,
      last_block_time: "2023-10-02T12:00:00Z",
      created_date: "2023-10-02T12:00:00Z",
      last_modified_date: "2023-10-02T12:00:00Z",
    },
  ],
  count: 0,
};

const getTronRentRequestListDummyRes = {
  // create dummy data base on IRentRequestDataResponse
  rows: [
    {
      wallet_address: "T1234567890abcdefg",
      batchId: "BATCH123",
      stepSequence: 1,
      transactionSequence: 1,
      status: "PENDING",
      requiredEnergy: 500,
      requiredBandwidth: 1000,
      lastBandwidthBlockNumber: 12345678,
      lastEnergyBlockNumber: 12345678,
      created_date: "2023-10-01T12:00:00Z",
      last_modified_date: "2023-10-01T12:00:00Z",
    },
    {
      wallet_address: "Tabcdefg1234567890",
      batchId: "BATCH456",
      stepSequence: 2,
      transactionSequence: 2,
      status: "COMPLETED",
      requiredEnergy: 800,
      requiredBandwidth: 1200,
      lastBandwidthBlockNumber: 87654321,
      lastEnergyBlockNumber: 87654321,
      created_date: "2023-10-02T12:00:00Z",
      last_modified_date: "2023-10-02T12:00:00Z",
    },
  ],
  count: 0,
};

// Balance Tab

export interface Wallet {
  id: string;
  merchant_id: string;
  wallet_type: number;
  wallet_address: string;
  chain_type: number;
  chain_id: string;
  status: number;
  wallet_name: string;
  client_id: null;
  is_default: boolean;
  wallet_version: null;
  wallet_path: null;
  wallet_index: null;
  created_by: null;
  created_date: Date;
  last_modified_date: Date;
  data_signature: string;
  data_signature_version: number;
  data_signer_server_type: number;
  data_signer_server_id: string;
  display_name: null;
  save_records: boolean;
  risk_level: number;
  no_risk_level_count: number;
  control_groups: null;
  assign_wallet_time: null;
  smart_account_type: null;
}
export interface ITronWalletResourceBalance {
  id: string;
  chain_type: number;
  chain_id: string;
  wallet_address: string;
  energy: string;
  bandwidth: string;
  last_block_number: string;
  last_block_time: string;
  created_date: string;
  last_modified_date: string;
  wallet: Wallet;
}

export interface IGetTronWalletResourceBalanceListParams {
  page: number;
  pageSize: number;

  displayName: string[];
  walletType: string[];
  chainType: number | null;
  chainId: number | null;
  walletAddress: string[];
  walletStatus: string[];
}

// Rent Request Tab
export interface IGetTronRentRequestListParams {
  page: number;
  pageSize: number;
  dateCreatedFrom?: string;
  dateCreatedTo?: string;
  dateLastModifiedFrom?: string;
  dateLastModifiedTo?: string;

  chainType: number | null;
  chainId: number | null;
  status: string[];
  // batchId: string[];
  walletTypes: string[];
  walletAddress: string[];
}

export interface IGetTronRentRequestListRes {
  id: string;
  merchant_id: string;
  batch_id: string;
  step_seq: number;
  wallet_address: string;
  required_energy: string;
  required_bandwidth: string;
  tx_seq: number;
  last_bandwidth_block_number: number;
  last_bandwidth: number;
  last_energy_block_number: number;
  last_energy: number;
  status: number;
  step: number;
  created_date: Date;
  last_modified_date: Date;
}

export const getTronWalletResourceBalanceList = async (
  params: IGetTronWalletResourceBalanceListParams,
  config = {}
) => {
  const { pageSize, page, ...restParams } = params;

  const payload = {
    ...restParams,
    limit: pageSize,
    offset: pageSize * page,
  };

  const res = await axios.get<
    never,
    { rows: ITronWalletResourceBalance[]; count: number }
  >(EndPtTronRentResourceBalance.tabBaPrefix, {
    params: payload,
    ...config,
  });

  return res;
};

export async function getTronWalletResourceBalanceListExport(
  params: IGetTronWalletResourceBalanceListParams,
  config?: any
) {
  const { pageSize, page, ...rest } = params;

  const payload = { ...rest, limit: pageSize, offset: pageSize * page };

  return await axios.get<never, any>(EndPtTronRentResourceBalance.tabBaExport, {
    params: { ...payload },
    ...config,
  });
}

export const getTronRentRequestList = async (
  params: IGetTronRentRequestListParams,
  config = {}
) => {
  const { pageSize, page, ...restParams } = params;

  const payload = {
    ...restParams,
    limit: pageSize,
    offset: pageSize * page,
  };

  const res = await axios.get<
    never,
    { rows: IGetTronRentRequestListRes[]; count: number }
  >(EndPtTronRentResourceBalance.tabReqPrefix, {
    params: payload,
    ...config,
  });

  // return getTronRentRequestListDummyRes;

  return res;
};

export async function getTronRentRequestListExport(
  params: IGetTronRentRequestListParams,
  config?: any
) {
  const { pageSize, page, ...rest } = params;

  const payload = { ...rest, limit: pageSize, offset: pageSize * page };

  return await axios.get<never, any>(
    EndPtTronRentResourceBalance.tabReqExport,
    {
      params: { ...payload },
      ...config,
    }
  );
}

export interface ReqRentTronResources {
  chainType: number | null;
  chainId: number | null;
  walletAddress: string;
  requiredEnergy?: string;
  requiredBandwidth?: string;
  rentPeriodSecond: string;

  orderId?: string;
  merchantId?: string;
}

export async function balanceTabRent(
  params: ReqRentTronResources,
  config?: any
) {
  const payload = {
    ...params,
  };

  return await axios.post<never, any>(EndPtTronRentResourceBalance.tabBaRent, {
    ...payload,
  });
}
export async function rentRequestTabRent(
  params: ReqRentTronResources,
  config?: any
) {
  const payload = {
    ...params,
  };

  return await axios.post<never, any>(EndPtTronRentResourceBalance.tabReqRent, {
    ...payload,
  });
}

export interface BalanceTabRefreshReq {
  chainType: number | null;
  chainId: number | null;
  walletAddress: string;
}

export async function balanceTabRefresh(params: BalanceTabRefreshReq) {
  return await axios.post<never, any>(
    EndPtTronRentResourceBalance.tabBaRefresh,
    {
      ...params,
    }
  );
}
